import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { findMissionVisibilityLabel } from './findMissionVisibilityLabel';
import { Chip } from '@mui/material';
import { MissionVisibility } from '@wwf/sdk';

export const MissionVisibilityChip = ({
    visibility,
}: {
    visibility: MissionVisibility;
}) => {
    const { missionVisibilityLabels } = useConfigurationContext();

    const label = findMissionVisibilityLabel(
        missionVisibilityLabels,
        visibility
    );
    return (
        <Chip
            label={label?.label}
            icon={
                label && label.icon ? (
                    <label.icon sx={{ fontSize: 20, color: 'black' }} />
                ) : undefined
            }
            size="small"
        />
    );
};
